export enum GroupTypes {
  Core = 1,
  Organizational = 2,
  Content = 3,
}
